import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Section } from "./_Section";
import * as yup from "yup";
import { clearMask, showToast } from "../../utils";
import { Flex, FormControl } from "@chakra-ui/react";
import { Input } from "../../components/Forms/Input";
import { useSeller } from "../../hooks/useSeller";
import { useEffect } from "react";

const editContactSchema = yup.object().shape({
  name: yup.string().required("Preenchimento obrigatório!"),
  email: yup.string().required("Preenchimento obrigatório!"),
  phone: yup.string().required("Preenchimento obrigatório!"),
});

interface ContactSectionProps {
  editSection: string;
  setEdit: (name: string) => void;
  id: string | undefined;
  contact: {
    name: string;
    email: string;
    phone: string;
  }
}

export interface ContactSectionData {
  name: string;
  email: string;
  phone: string;
}

export function ContactSection({ editSection, setEdit, id, contact }: ContactSectionProps) {
  const { patchContacts } = useSeller();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(editContactSchema),
  });

  function setDefaultData() {
    setValue("name", contact?.name);
    setValue("email", contact?.email);
    setValue("phone", contact?.phone);
  }

  const onSubmit = handleSubmit(async ({name, email, phone}: ContactSectionData) => {
    if (editSection === "contact") {
      try {
        const contactData = {
          name: name,
          email: email,
          phone: clearMask(phone),
        }
        await patchContacts(contactData, id);
        setEdit("");
        showToast({ message: "Informacoes editadas com sucesso", type: "success" });
      } catch (error: any) {
        setEdit("");
        error?.response?.data?.errors?.map((error:any) => (
          showToast({
            type: "error",
            message: `${error?.code} - ${error?.description}`
          })
        ));
      }
    }
  });

  useEffect(() => {
    setDefaultData();
    //eslint-disable-next-line
  }, []);

  return (
    <Section
      sectionTitle="Contato"
      isEdit={editSection === "contact"}
      onClickEditButton={() => {
        setEdit("contact");
      }}
      onClickConfirmButton={onSubmit}
    >
      <Flex gap={4} >
        <FormControl maxWidth="280px">
          <Input
            label="Nome"
            defaultValue={contact?.name}
            name="name"
            p="0"
            register={{ ...register("name") }}
            _disabled={{
              bg: "transparent",
              border: "none",
            }}
            isDisabled={editSection !== "contact"}
            errors={errors?.name}
          />
        </FormControl>
        <FormControl maxWidth="280px">
          <Input
            label="E-mail"
            defaultValue={contact?.email}
            name="email"
            p="0"
            register={{ ...register("email") }}
            _disabled={{
              bg: "transparent",
              border: "none",
            }}
            isDisabled={editSection !== "contact"}
            errors={errors?.email}
          />
        </FormControl>
        <FormControl maxWidth="280px">
          <Input
            label="Telefone"
            defaultValue={contact?.phone}
            name="phone"
            p="0"
            register={{ ...register("phone") }}
            _disabled={{
              bg: "transparent",
              border: "none",
            }}
            isDisabled={editSection !== "contact"}
            mask="(99) 9 9999-9999"
            errors={errors?.phone}
          />
        </FormControl>
      </Flex>
    </Section>
  );
}